import { type Device } from "@features/createDeviceConfiguration/graphql/querys/getUpdateHardwareConfigurationData";
import { Grid } from "@mui/material";
import { Control, UseFormSetValue } from "react-hook-form";
import { FormValues } from 'src/features/createDeviceConfiguration/type/FormValues';
import DeviceSensorsForm from "./DeviceSensorsForm";

interface SensorizationTabContentProps {
  device: Device;
  control: Control<FormValues>;
  setValue: UseFormSetValue<FormValues>;
  readOnly?: boolean;
}

const SensorizationTabContent = ({
  device,
  control,
  setValue,
  readOnly = false,
}: SensorizationTabContentProps) =>   {
  return (
    <Grid item xs={12} sm={8} p={2} mt={2}>
      <DeviceSensorsForm
        device={device}
        control={control}
        setValue={setValue}
        readOnly={readOnly}
      />
    </Grid>
  );
};

export default SensorizationTabContent;
